import React, { useState, useEffect } from 'react';
import ReadingExerciseList from '../components/ReadingExerciseList';
import ReadingExerciseEdit from '../components/ReadingExerciseEdit';
import styled from 'styled-components';

type IProps = {
  readingExerciseId: number;
};

const ReadingExercise: React.FC<IProps> = ({ readingExerciseId }) => {
  const [editExercise, setEditExercise] = useState(readingExerciseId);

  // Load exercise when navigated from external source
  useEffect(() => {
    setEditExercise(readingExerciseId);
  }, [readingExerciseId]);

  const onEditExercise = (exerciseId: number) => {
    setEditExercise(exerciseId);
  };

  return (
    <Container>
      <ReadingExerciseList onEditExercise={onEditExercise} editingExerciseId={editExercise} />
      <ReadingExerciseEdit readingExerciseId={editExercise} key={editExercise} />
    </Container>
  );
};

export default ReadingExercise;

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
